import React from 'react'
import { getDisplayName } from '../../../helpers/get-display-name'
import style from './index.module.scss'

export interface AngleMaskClassesProps {
  angleClasses: any
}

export type AngleMaskWrapperProps<P> = { children?: React.ReactNode } & Pick<
  P,
  Exclude<keyof P, keyof AngleMaskClassesProps>
>

// See here for why we need to declare HOC like this:
// https://stackoverflow.com/questions/51083920/how-to-handle-props-injected-by-hoc-in-react-with-typescript
const withAngleMaskClasses = <P extends AngleMaskClassesProps>(
  Component: React.ComponentType<P>
): React.FC<AngleMaskWrapperProps<P>> => {
  const wrapper = (props: AngleMaskWrapperProps<P>): JSX.Element => (
    // NB: Fixing this was very bad effort to value
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    <Component angleClasses={style} {...props} />
  )

  const name = getDisplayName(Component)
  wrapper.displayName = `withAngleMaskClasses(${name})`
  return wrapper
}

export default withAngleMaskClasses
